import styled from 'styled-components'

export const ContentContainer = styled.div`
  padding: 20px;
  width: 100%;
`

export const FormContainer = styled.div`
  margin-top: 18px;
`

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 12px auto;
`

export const ButtonsContainer = styled.div`
  width: 100%;
  flex: 1 1 0%;
  justify-content: flex-end;
  align-items: flex-end;
  float: right;
  display: flex;
  margin-top: 20px;
  button:first-of-type {
    margin-right: 10px;
  }
`
